var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from "react";
import styled from "styled-components";
import { LinearProgress, Typography, withStyles } from "@material-ui/core";
var BorderLinearProgress = withStyles(function (theme) {
  return {
    root: {
      height: 25,
      borderRadius: 10
    },
    colorPrimary: {
      borderRadius: 10
    },
    bar: {
      borderRadius: 10,
      backgroundColor: "#0275d8"
    }
  };
})(LinearProgress);
var ProgressBarBackground = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 25px;\n  overflow: hidden;\n  text-align: center;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 25px;\n  overflow: hidden;\n  text-align: center;\n  position: relative;\n"])));
var ProgressBarText = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  color: white;\n  z-index: 1;\n  display: block;\n  position: absolute;\n"], ["\n  width: 100%;\n  color: white;\n  z-index: 1;\n  display: block;\n  position: absolute;\n"])));
var TestProgressBar = function TestProgressBar(_a) {
  var percentage = _a.percentage;
  if (!percentage && percentage !== 0) return null;
  return React.createElement("div", {
    style: {
      marginLeft: "10px"
    }
  }, React.createElement(ProgressBarBackground, null, React.createElement(ProgressBarText, {
    variant: "button"
  }, percentage, " %"), React.createElement(BorderLinearProgress, {
    variant: "determinate",
    value: percentage
  })));
};
export default TestProgressBar;
var templateObject_1, templateObject_2;